import { styled } from "@linaria/react"

import { focusOutline } from "@/styles/mixins.ts"

import type { MouseEventHandler } from "react"


export const Toggle = ({ active, onClick, disabled }: {
  active: boolean
  onClick?: MouseEventHandler
  disabled?: boolean
}) => {
  return (
    <ToggleTrack active={active} onClick={onClick} disabled={disabled}>
      <ToggleThumb active={active} />
    </ToggleTrack>
  )
}

const ToggleTrack = styled.button<{ active: boolean, disabled?: boolean }>`
  position: relative;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: ${props => props.active ? "flex-end" : "flex-start"};

  width: 32px;
  height: 20px;

  padding: 0 2px;

  border: none;
  border-radius: 30px;

  cursor: pointer;
  transition: background 0.3s ease;

  background: ${props => props.active
    ? "radial-gradient(122.66% 77.21% at 71.87% 50%, var(--main-color) 0%, oklch(81.4% 0.097 284.043deg) 100%)"
    : "oklch(90.7% 0 89.876deg)"};

  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? "none" : "auto"};

  &:active {
    filter: ${props => props.active ? "brightness(0.95)" : "brightness(0.9)"};
  }

  &:hover:not(:disabled) {
    filter: ${props => props.active ? "brightness(1.05)" : "brightness(0.95)"};
  }

  &:focus-visible {
    ${focusOutline};
  }
`

const ToggleThumb = styled.div<{ active: boolean }>`
  width: 16px;
  height: 16px;

  background-color: var(--background-color);
  border-radius: var(--border-radius-round);
  box-shadow: 0 2px 4px var(--separator-color);

  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1;

  &:hover {
    transform: scale(1.05);
  }
`
